var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8197,
    cy: 10.8197,
    r: 10.8197,
    fill: "#F5AB38"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5279_23741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0746 5.81761L12.0519 6.84041L14.799 9.58759L15.8218 8.5648C16.3501 8.03649 16.3501 7.18064 15.8218 6.65234L14.9892 5.81761C14.4609 5.28931 13.6051 5.28931 13.0768 5.81761H13.0746ZM11.5743 7.318L6.64836 12.246C6.42858 12.4658 6.26798 12.7384 6.17922 13.0364L5.43114 15.5786C5.37831 15.7582 5.42692 15.9505 5.55793 16.0815C5.68895 16.2125 5.88126 16.2611 6.05877 16.2104L8.60097 15.4623C8.89893 15.3736 9.17154 15.213 9.39131 14.9932L14.3214 10.0652L11.5743 7.318Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5279_23741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8197,
    height: 10.8197,
    fill: "white",
    transform: "translate(5.41016 5.40991)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAvatar);
export default __webpack_public_path__ + "static/media/editAvatar.5f7117711f18730e87bf8a14916d3486.svg";
export { ForwardRef as ReactComponent };